import { useCallback, useEffect, useRef, useState } from 'react'

const DURACAO_DO_AVISO_MS = 1600

/** Copia para a área de transferência e devolve `copiado` por um instante, para
 *  o botão trocar o ícone em vez de abrir um toast por cima do painel. */
export function useCopiar() {
  const [copiado, setCopiado] = useState(false)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const copiar = useCallback(async (texto: string) => {
    try {
      await navigator.clipboard.writeText(texto)
    } catch {
      return
    }
    setCopiado(true)
    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => setCopiado(false), DURACAO_DO_AVISO_MS)
  }, [])

  useEffect(() => () => {
    if (timerRef.current) clearTimeout(timerRef.current)
  }, [])

  return { copiado, copiar }
}
